// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@eisinc/App/SharedStyles/CartLineSharedStyles";
import { quickOrderProductListStyles } from "@eisinc/Overrides/Widgets/QuickOrder/QuickOrderProductList";
import { customBadgesStyles, xScreen } from "@eisinc/XDL/Utilities";
import { css } from "styled-components";

quickOrderProductListStyles.wrapper = {
    css: css`
        padding-bottom: 20px;
    `,
};

quickOrderProductListStyles.productImage = {
    ...cartLineSharedStyles.productImage,
};

quickOrderProductListStyles.productDescription = {
    ...cartLineSharedStyles.productDescription,
};

quickOrderProductListStyles.productNumber = {
    ...cartLineSharedStyles.productPartNumbers,
};

quickOrderProductListStyles.availability = {
    ...cartLineSharedStyles.productAvailability,
};

quickOrderProductListStyles.price = {
    ...cartLineSharedStyles.productPrice,
};

quickOrderProductListStyles.removeLink = {
    ...cartLineSharedStyles.removeLink,
};

quickOrderProductListStyles.addToListLink = {
    link: {
        ...cartLineSharedStyles.addToListLink,
    },
};

quickOrderProductListStyles.cartLineContainer = {
    actions: {
        css: css`
            ${xScreen("lte", "md")} {
                grid-column: 1 / 3;
                grid-row: 4 / 5;
            }
        `,
    },
    description: {
        css: css`
            gap: 8px;
        `,
    },
};

quickOrderProductListStyles.badgesContainerStyle = { ...customBadgesStyles.container };
